module.exports = __webpack_public_path__ + "img/YN.891ffbcf.png";